import type { FieldValues, UseFormSetValue } from 'react-hook-form';
import type { GooglePlacesResult } from 'src/views/Coversheet/utils/googlePlaces';

export const addressAutofillHelper = (
  autofillValue: GooglePlacesResult | string,
  setValue?: UseFormSetValue<FieldValues>,
) => {
  Object.entries(autofillValue).forEach(([key, value]) => {
    if (value && setValue) {
      setValue(key, value, {
        shouldValidate: true,
      });
    }
  });
};
